import { FC } from 'react';
// Redux
import { useAppDispatch } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
// Components
import Icon from 'components/Icon';
// Utilities
import { expandAccordion } from 'utilities/utilities';

type Props = {
  menuItem: any;
  active: boolean;
  error?: boolean;
}

const MenuItem:FC<Props> = ({
  // Props
  menuItem, active, error
}) => {
  const dispatch = useAppDispatch();

  const handeClick = () => {
    dispatch(appActions.setQuizFormMenuItem(menuItem.value));
    expandAccordion(menuItem.value);
    dispatch(appActions.toggleQuizFormSidebar());
  }

  const classes = active
    ? 'bg-primary-light text-primary'
    : 'text-white'
  ;

  return (
    <div
      className={`
        ${classes}
        flex items-center gap-2
        rounded-xl
        hover:bg-primary-light cursor-pointer
        p-4
      `}
      onClick={handeClick}
    >
      {menuItem.icon ? <Icon icon={menuItem.icon} /> : null}
      <span className="flex-grow text-base text-left">{menuItem.label}</span>
      {error ? (
        <Icon
          className="text-red-500"
          icon="error_outline"
        />
      ) : null}
    </div>
  )
}

export default MenuItem;
